import React from 'react';
import getInitialPropsForServicePage from 'helpers/services/getServiceProps';
import { INDIVIDUAL_SERVICE_PAGE } from 'constants/Services';
import { ServicePage } from 'views/Services';
import configureStore from 'state/configureStore';
import getServerSidePropsWrapper from 'helpers/getServerSidePropsWrapper';

export const IndividualService = (props) => <ServicePage {...props} />;

export const getServerSideProps = configureStore.getServerSideProps(
  (store) => async (ctx) =>
    await getServerSidePropsWrapper({ ...ctx, store }, async (ctx) => {
      const { res, store, query, req } = ctx;
      return await getInitialPropsForServicePage(res, store, query, INDIVIDUAL_SERVICE_PAGE, req);
    })
);

export default IndividualService;
